import { API } from 'aws-amplify';

export const getSchools = async () => {
  const schools = await API.get('delta-api', `online-attendance/schools`, {});
  return schools;
};
